import React from "react";
import Card from "./Card";
import Title from "./Title";
import { useAmn } from "../../contexts/AmnContext";
import { ReactComponent as PDF } from "./icons/pdf.svg";

interface PageProps {
  content: {
    title: string;
    items: any[];
    color: string;
  };
  number: number;
  onChange: Function,
  isDebrief : boolean
}

const Page: React.FC<PageProps> = ({ content, number, onChange, children, isDebrief }) => {
  const amn = useAmn();

  const selected = content.title === "Résultats";
  console.log(selected);

  const pdfDisplay = (name : string, e:any) => {
    e.preventDefault()
    amn.setPdfToDisplay(name);
    amn.setShowPDF({show : true, disposition: "left"});
  }

  return (
    <section className={`ec-container ${content.color}`}>
      <Title>{content.title}</Title>
      <div className="ec-content">
        <div className="ec-cards">
          {content.items.map((Item, index) => (
            <Card
              key={number * 100 + index}
              color={Item.color || content.color}
              selected={selected}
              onChange={onChange}
              isDebrief={isDebrief}
              label = {Item.label}
            >
              {console.log({ Item, selected })}
              <Item.Icon />
              <p>{Item.label}</p>
              {Item.pdfLink && <div className={`ec-pdfLink ${Item.color}`}><PDF onClick={(e) => pdfDisplay(Item.pdfLink, e)}/></div>}
            </Card>
          ))}
          {children}
        </div>
      </div>
    </section>
  );
};

export default Page;
